import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing a fuel card icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <FuelCardIcon width={12} />
 */
const FuelCardIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M45.99,13.843v-1.086c0-2.355-1.926-4.281-4.281-4.281H6.337c-2.355,
            0-4.281,1.926-4.281,4.281v1.086H45.99z`}
        />
        <path
            d={`M2.056,18.421v16.216c0,2.355,1.926,4.281,4.281,4.281h35.372c2.355,
            0,4.281-1.926,4.281-4.281V18.421H2.056z`}
        />
    </SvgIcon>
)

FuelCardIcon.defaultProps = defaultProps

export { FuelCardIcon }
